export function formatDealPrice(value) {
  const price = Number(value);
  return Number.isFinite(price) && price > 0
    ? price.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 })
    : '';
}

export function spotlightDealReachCopy(data) {
  if (!data.mailer.mailboxCount) return 'Reach selected local mailboxes with a compelling offer that gives local residents a reason to discover your business.';
  const market = data.tenant.marketName ? `${data.tenant.marketName} residents` : 'local residents';
  return `Reach ${data.mailer.mailboxCount.toLocaleString()} local mailboxes with a compelling offer that gives ${market} a reason to discover your business.`;
}

export function buildSpotlightDealIncluded(data) {
  const price = formatDealPrice(data.spotlightDeal.price);
  return [
    price ? { icon: 'price', title: `${price} per mailing`, text: data.mailer.noLongTermContract === true ? 'No long-term commitment required.' : 'A focused, compact mailer placement.' } : null,
    { icon: 'mail', title: data.mailer.mailboxCount ? `${data.mailer.mailboxCount.toLocaleString()} local mailboxes` : 'Local mailbox delivery', text: data.tenant.marketName ? `Delivered to selected ${data.tenant.marketName} neighborhoods.` : 'Delivered to selected neighborhoods in your market.' },
    data.spotlightDeal.includedDesign ? { icon: 'layout', title: 'Professional layout', text: 'We turn your offer and business information into a clean, easy-to-read ad.' } : null,
    { icon: 'qr', title: 'QR-code ready', text: 'Send customers directly to your offer, website, or other destination.' },
    data.mailer.categoryExclusive === true ? { icon: 'exclusive', title: 'Category exclusivity', text: 'Subject to category and inventory availability.' } : null,
  ].filter(Boolean);
}

export function buildSpotlightDealBenefits(data) {
  return [
    { icon: 'mail', title: data.mailer.mailboxCount ? `${data.mailer.mailboxCount.toLocaleString()} Local Mailboxes` : 'Local Mailbox Delivery', text: 'Great visibility where it matters' },
    data.mailer.categoryExclusive === true ? { icon: 'exclusive', title: 'Category Exclusive', text: 'One business per eligible category' } : null,
    data.mailer.noLongTermContract === true ? { icon: 'flexible', title: 'No Long-Term Contract', text: 'Flexible participation by mailer' } : null,
  ].filter(Boolean);
}
